import {
  jetBrainsMono,
  mackinacPro,
  mergeIntoNextFontFamily,
  messinaSans,
} from './next';

export const SANS_SERIF_FONT_FAMILY = mergeIntoNextFontFamily(messinaSans, [
  'system-ui',
  '-apple-system',
  'BlinkMacSystemFont',
  'Segoe UI',
  'Roboto',
  'Oxygen-Sans',
  'Ubuntu',
  'Cantarell',
  'Helvetica',
  'Arial',
  'sans-serif',
  'Apple Color Emoji',
  'Segoe UI Emoji',
  'Segoe UI Symbol',
]);

export const CODE_FONT_FAMILY = mergeIntoNextFontFamily(jetBrainsMono, [
  'ui-monospace',
  'source-code-pro',
  'Menlo',
  'Monaco',
  'Consolas',
  '"Courier New"',
  'monospace',
]);

export const SERIF_FONT_FAMILY = mergeIntoNextFontFamily(mackinacPro, [
  'ui-serif',
  'Athelas',
  'Georgia',
  'Times New Roman',
  'serif',
]);
